// Tên gọi ngắn của nhân viên: tách theo khoảng trắng và lấy từ cuối
// ("Nguyễn Thị Hồng Ngọc" -> "Ngọc"). Giữ nguyên nếu trùng một trong các tên
// ngoại lệ (ví dụ tên nhà hàng dùng thay khi chưa có nhân viên).
const getShortName = (name, keepAsIs = []) => {
  const fullName = String(name || "").trim();
  if (!fullName) return "";
  if (keepAsIs.some((item) => item && String(item).trim() === fullName)) {
    return fullName;
  }
  const parts = fullName.split(/\s+/);
  return parts[parts.length - 1];
};

export default getShortName;
